// extracted by mini-css-extract-plugin
export default {"container":"MenuItem_container__ev5Vc","button":"MenuItem_button__v6ASH"};